module.exports = __webpack_public_path__ + "media/images/flags/1x1/ind-e1dde197d017e5d1fd48367812d89ad4.svg";